import React from 'react';
import { Space } from 'antd';
import { Paragraph } from 'app/components/Typography/Paragraph';
import moment from 'moment';
import { urlify } from 'app/utils';

export const DescriptionFields = [
  {
    label: 'Inspection Date',
    name: 'inspectionDate',
    defaultValue: 'N/A',
    render: (data: any) => {
      const { inspectionDate, inspectionEndDate, noOfManday } = data;
      const inspectionDateFormatted = inspectionDate
        ? moment(inspectionDate).format('DD/MM/YYYY')
        : 'N/A';
      const inspectionEndDateFormatted = inspectionEndDate
        ? moment(inspectionEndDate).format('DD/MM/YYYY')
        : 'N/A';
      const mandayFormatted = noOfManday
        ? `(${noOfManday} ${noOfManday > 1 ? 'days' : 'day'})`
        : '';
      return (
        <Paragraph>{`${inspectionDateFormatted} ${
          inspectionEndDateFormatted ? ' - ' + inspectionEndDateFormatted : ''
        } ${mandayFormatted}`}</Paragraph>
      );
    }
  },
  {
    label: 'Inspection Type',
    name: 'typeOfService',
    defaultValue: 'N/A'
  },
  {
    label: 'General Inspection Level',
    name: 'generalInspectLevel',
    defaultValue: 'N/A'
  },
  {
    label: 'Acceptance Quality Level',
    name: '',
    defaultValue: 'N/A',
    render: (values: any) => {
      return (
        <Space wrap>
          <Paragraph>Critical {values?.criticalLevel}</Paragraph>
          <Paragraph>Major {values?.criticalMajorLevel}</Paragraph>
          <Paragraph>Minor {values?.criticalMinorLevel}</Paragraph>
        </Space>
      );
    }
  },
  {
    label: 'Inspector',
    name: 'assignTo',
    defaultValue: 'N/A',
    render: (data: any) => {
      const { assignTo }: any = data;
      return (
        <div>
          {(assignTo || []).map(
            ({ firstName, lastName, inspectionDates }: any, index: number) => {
              const inspectionDateLabel = inspectionDates.map(
                ({ date, manday }: { date: string; manday: number }) => {
                  return `${moment(date).format('DD/MM/YYYY')} (${manday} ${
                    manday > 1 ? 'days' : 'day'
                  })`;
                }
              );
              return (
                <Paragraph key={index}>
                  {`${firstName} ${lastName}`}: {inspectionDateLabel.join(', ')}
                </Paragraph>
              );
            }
          )}
        </div>
      );
    }
  },
  {
    label: 'Rejected Reason By Inspector',
    name: 'rejectReasons',
    defaultValue: 'N/A',
    render: (data: any) => {
      const { assignTo, rejectReasons }: any = data;
      if (!rejectReasons || !rejectReasons.length) return <></>;
      return (
        <div>
          {(assignTo || []).map(
            ({ firstName, lastName, userId }: any, index: number) => {
              const rejectReason = (rejectReasons || []).find((reject: any) => {
                return reject.userId === userId;
              });
              return (
                <Paragraph key={index}>
                  {`${firstName} ${lastName}`}: {rejectReason?.reason || 'N/A'}
                </Paragraph>
              );
            }
          )}
        </div>
      );
    }
  },
  {
    label: 'Check In / Check Out ',
    name: '',
    defaultValue: 'N/A',
    render: (data: any) => {
      const { checkinTime, checkoutTime } = data;
      const checkinTimeFormatted = checkinTime
        ? moment(checkinTime).format('DD/MM/YYYY hh:mm A')
        : 'N/A';
      const checkoutTimeFormatted = checkoutTime
        ? moment(checkoutTime).format('DD/MM/YYYY hh:mm A')
        : 'N/A';

      return (
        <Paragraph>{`${checkinTimeFormatted} / ${checkoutTimeFormatted}`}</Paragraph>
      );
    }
  },
  {
    label: 'Remark',
    name: 'remark',
    multiple: true,
    defaultValue: `N/A`,
    render: (values: any) => {
      return (
        <Paragraph>
          <p
            dangerouslySetInnerHTML={{
              __html: `<div>${urlify(values.remark)}</div>`
            }}
          ></p>
        </Paragraph>
      );
    }
  }
];
